var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextTokenomic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 1490 371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M753.039 351.771H780.36V370.838H753.039z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.343-.7H.011v.1h.113V0H.23v-.6h.113v-.1z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(648.024 6714.7) scale(88.4358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(678.976 6714.7) scale(88.4358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.423-.7H.312l-.147.292H.163V-.7H.057V0h.106v-.216l.046-.09L.313 0h.113L.279-.422.423-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(717.269 6714.7) scale(88.4358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.355-.7H.057V0h.298v-.098H.163v-.208h.155v-.098H.163v-.198h.192V-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(754.589 6714.7) scale(88.4358)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.402-.7h-.1v.417H.3L.175-.7H.057V0h.1v-.464h.002L.298 0h.104v-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(788.902 6714.7) scale(88.4358)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(829.494 6714.7) scale(88.4358)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.506-.7H.363l-.082.376H.279L.196-.7H.057V0h.1v-.486h.002L.247-.1H.31l.088-.386H.4V0h.106v-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(867.875 6714.7) scale(88.4358)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M0.057 -0.7H0.163V0H0.057z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(917.665 6714.7) scale(88.4358)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.209-.71c-.103 0-.163.062-.163.168v.384c0 .106.06.168.163.168.104 0 .165-.062.165-.168v-.084L.272-.247v.078c0 .056-.021.081-.06.081-.039 0-.06-.025-.06-.071v-.382c0-.046.021-.071.06-.071.039 0 .06.025.06.081v.057l.102-.005v-.063C.374-.648.313-.71.209-.71z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(937.121 6714.7) scale(88.4358)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.181-.71c-.101 0-.158.057-.158.157v.015c0 .082.033.14.13.222.071.06.092.095.092.139v.023c0 .044-.02.066-.06.066-.04 0-.06-.022-.06-.066v-.05l-.102.01v.047c0 .1.059.157.164.157.105 0 .164-.057.164-.157v-.035c0-.084-.036-.142-.133-.224C.147-.466.129-.501.129-.542v-.009c0-.04.019-.061.054-.061s.054.021.054.061v.026l.102-.01v-.018c0-.1-.057-.157-.158-.157z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(973.291 6714.7) scale(88.4358)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.343-.7H.011v.1h.113V0H.23v-.6h.113v-.1z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(645.99 6714.7) scale(88.4358)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(676.942 6714.7) scale(88.4358)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.423-.7H.312l-.147.292H.163V-.7H.057V0h.106v-.216l.046-.09L.313 0h.113L.279-.422.423-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(715.235 6714.7) scale(88.4358)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.355-.7H.057V0h.298v-.098H.163v-.208h.155v-.098H.163v-.198h.192V-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(752.555 6714.7) scale(88.4358)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.402-.7h-.1v.417H.3L.175-.7H.057V0h.1v-.464h.002L.298 0h.104v-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(786.868 6714.7) scale(88.4358)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(827.46 6714.7) scale(88.4358)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.506-.7H.363l-.082.376H.279L.196-.7H.057V0h.1v-.486h.002L.247-.1H.31l.088-.386H.4V0h.106v-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(865.841 6714.7) scale(88.4358)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M0.057 -0.7H0.163V0H0.057z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(915.631 6714.7) scale(88.4358)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.209-.71c-.103 0-.163.062-.163.168v.384c0 .106.06.168.163.168.104 0 .165-.062.165-.168v-.084L.272-.247v.078c0 .056-.021.081-.06.081-.039 0-.06-.025-.06-.071v-.382c0-.046.021-.071.06-.071.039 0 .06.025.06.081v.057l.102-.005v-.063C.374-.648.313-.71.209-.71z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(935.087 6714.7) scale(88.4358)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.181-.71c-.101 0-.158.057-.158.157v.015c0 .082.033.14.13.222.071.06.092.095.092.139v.023c0 .044-.02.066-.06.066-.04 0-.06-.022-.06-.066v-.05l-.102.01v.047c0 .1.059.157.164.157.105 0 .164-.057.164-.157v-.035c0-.084-.036-.142-.133-.224C.147-.466.129-.501.129-.542v-.009c0-.04.019-.061.054-.061s.054.021.054.061v.026l.102-.01v-.018c0-.1-.057-.157-.158-.157z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(971.257 6714.7) scale(88.4358)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.343-.7H.011v.1h.113V0H.23v-.6h.113v-.1z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(646.963 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(677.915 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.423-.7H.312l-.147.292H.163V-.7H.057V0h.106v-.216l.046-.09L.313 0h.113L.279-.422.423-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(716.208 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.355-.7H.057V0h.298v-.098H.163v-.208h.155v-.098H.163v-.198h.192V-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(753.528 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.402-.7h-.1v.417H.3L.175-.7H.057V0h.1v-.464h.002L.298 0h.104v-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(787.841 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.217-.71c-.106 0-.171.067-.171.177v.366c0 .11.065.177.171.177.106 0 .171-.067.171-.177v-.366c0-.11-.065-.177-.171-.177zm0 .098c.042 0 .065.028.065.08v.364c0 .052-.023.08-.065.08S.152-.116.152-.168v-.364c0-.052.023-.08.065-.08z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(828.433 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.506-.7H.363l-.082.376H.279L.196-.7H.057V0h.1v-.486h.002L.247-.1H.31l.088-.386H.4V0h.106v-.7z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(866.814 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M0.057 -0.7H0.163V0H0.057z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(916.603 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.209-.71c-.103 0-.163.062-.163.168v.384c0 .106.06.168.163.168.104 0 .165-.062.165-.168v-.084L.272-.247v.078c0 .056-.021.081-.06.081-.039 0-.06-.025-.06-.071v-.382c0-.046.021-.071.06-.071.039 0 .06.025.06.081v.057l.102-.005v-.063C.374-.648.313-.71.209-.71z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(936.059 6714.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M.181-.71c-.101 0-.158.057-.158.157v.015c0 .082.033.14.13.222.071.06.092.095.092.139v.023c0 .044-.02.066-.06.066-.04 0-.06-.022-.06-.066v-.05l-.102.01v.047c0 .1.059.157.164.157.105 0 .164-.057.164-.157v-.035c0-.084-.036-.142-.133-.224C.147-.466.129-.501.129-.542v-.009c0-.04.019-.061.054-.061s.054.021.054.061v.026l.102-.01v-.018c0-.1-.057-.157-.158-.157z",
    transform: "translate(-2695.68 -27672.6) scale(4.16667) translate(972.23 6714.7) scale(88.4358)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M679.185 163.242H695.577V193.292H679.185z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M839.656 276.05H854.2139999999999V290.608H839.656z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M143.368 125.925H161.126V143.683H143.368z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M1317.75 162.058H1328.575V167.525H1317.75z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M1108.69 19.912H1138.602V36.304H1108.69z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M682.006 351.771H753.039V370.838H682.006z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1328.57 162.058H1366.82V167.525H1328.57z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1256.72 296.838H1286.7740000000001V318.696H1256.72z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1138.6 19.912H1146.7959999999998V36.304H1138.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M479.501 325H520.48V352.321H479.501z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M904.185 61.354H936.968V74.083H904.185z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M571.135 0H636.706V13.663H571.135z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTokenomic);
export default __webpack_public_path__ + "static/media/text-tokenomic.68d7c15fea49998cf795a66adc3cb0fb.svg";
export { ForwardRef as ReactComponent };